export enum LicenseType {
    AC_License = 1,
    LT_License = 2,
    
}